import axios from "axios";
import { z } from "zod";

const openQuestionSchema = z.object({
  id: z.number().int(),
  kind: z.enum([
    "string",
    "text",
    "single_choice",
    "multi_choice",
    "file",
    "boolean",
    "legal",
  ]),
  required: z.boolean(),
  position: z.number(),
  body: z.string(),
  open_question_options: z.array(
    z.object({
      body: z.string(),
      id: z.number().int(),
      position: z.number(),
    })
  ),
});

const visibilityOptions = ["required", "optional", "off"] as const;

const jobOfferDetailsSchema = z.object({
  id: z.number().int(),
  slug: z.string().min(1),
  options_cv: z.enum(visibilityOptions),
  options_cover_letter: z.enum(visibilityOptions),
  options_phone: z.enum(visibilityOptions),
  options_photo: z.enum(visibilityOptions),
  open_questions: z.array(openQuestionSchema),
});

export const recruiteeAllowedMimeTypes = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "application/pdf",
  "image/png",
  "application/vnd.oasis.opendocument.text",
  "application/rtf",
] as const;

export type RecruiteeJobOfferDetails = z.infer<typeof jobOfferDetailsSchema>;
export type RecruiteeOpenQuestion = z.infer<typeof openQuestionSchema>;

export const fetchJobOfferDetails = async (
  companySlug: string,
  jobOfferSlug: string
) => {
  const url = `${constructApiUrlForCompany(
    companySlug
  )}/offers/${jobOfferSlug}`;

  const response = await fetch(url);
  const body = await response.json();

  return jobOfferDetailsSchema.parse(body.offer);
};

export const constructApiUrlForCompany = (companySlug: string) =>
  `https://${companySlug}.recruitee.com/api`;

export const submitJobOfferCandidate = async (
  companySlug: string,
  jobOfferSlug: string,
  data: FormData
) => {
  const submitApiUrl = `${constructApiUrlForCompany(
    companySlug
  )}/offers/${jobOfferSlug}/candidates`;

  return axios.post(submitApiUrl, data).then((res) => res.data);
};
